export const environment = {
    production: false,
    API_ORIGIN: 'https://smarthink-core.azurewebsites.net/api',
    AUTH_ORIGIN: 'https://auth-prod.smarthink.gr/',
    AZURE_MEASUREMENTS_URL: 'https://measurement-prod.smarthink.gr/api',
    AZURE_CORE_URL: 'https://smarthink-core.azurewebsites.net/api'
};
